/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SeminarEventLocation {
    VIRTUAL = 'virtual',
    ONSITE = 'onsite',
    NOT_FIXED = 'not-fixed',
}
